import { defineTracking } from 'services/google-analytics';

const category = 'new landing page - online support';

export default {
  ...defineTracking({
    startChat: {
      category,
      action: 'click',
      label: 'start support chat button',
      description: 'This event is triggered when a user clicks the Start Support Chat button.',
    },
    minimizeChat: {
      category,
      action: 'click',
      label: 'minimize support chat button',
      description: 'This event is triggered when a user clicks to minimize the Support Chat window.',
    },
    maximizeChat: {
      category,
      action: 'click',
      label: 'maximize support chat button',
      description: 'This event is triggered when a user clicks to maximize the Support Chat window.',
    },
    endChat: {
      category,
      action: 'click',
      label: 'end support chat button',
      description: 'This event is triggered when a user clicks the End Support Chat button.',
    },
    kicked: {
      category,
      action: 'kicked',
      label: 'suport chat session kicked',
      description: 'This event is triggered when a support chat session is ended.',
    },
  }),
};
